import React from "react";

function SvgIcMapPoi054(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M7.276 13.677c.395-.394.917-.61 1.474-.61.556 0 1.08.216 1.473.61l3.531 3.53-2.947 2.947-3.53-3.531a2.086 2.086 0 010-2.946M8.75 11.4c.886 0 1.773.312 2.479.935l.172.162 7.071 7.072a3.747 3.747 0 010 5.302 3.736 3.736 0 01-2.652 1.099 3.735 3.735 0 01-2.478-.937l-.173-.162-7.07-7.07A3.75 3.75 0 018.75 11.4zm15.556-3.293c.437.694.694 1.513.694 2.392a4.5 4.5 0 01-4.5 4.5 4.47 4.47 0 01-2.392-.693zM20.5 6c.792 0 1.534.208 2.18.568l.213.125-6.2 6.2A4.475 4.475 0 0116 10.5 4.5 4.5 0 0120.5 6z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi054;
